import {
   CurrentHealthcareProviderNfzConfigurationSetCommand,
   HealthcareProviderNfzConfiguration,
} from '@dreryk/egabinet-nfz-configuration-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { useFormController } from '@dreryk/react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { draftPrescriptionsTranslationKeys } from '../../../../../translations';

import { NfzDepartmentFormBean, NfzDepartmentFormController } from './NfzDepartmentForm.types';

export const useNfzDepartmentFormController = (): NfzDepartmentFormController => {
   return useFormController<NfzDepartmentFormBean>({
      nfzDepartment: null,
   });
};

type CurrentHealthcareProviderNfzConfigurationSetCommandOptions = {
   onSuccess: () => void;
};

export const useCurrentHealthcareProviderNfzConfigurationSetCommand = (
   options: CurrentHealthcareProviderNfzConfigurationSetCommandOptions
): UseCqrsCommandResult<HealthcareProviderNfzConfiguration, NfzDepartmentFormBean> => {
   const { onSuccess } = options;

   return useCqrsCommand(
      (parameters) => {
         const command = new CurrentHealthcareProviderNfzConfigurationSetCommand();
         command.nfzDepartmentId = parameters.nfzDepartment!.id;
         command.contractingPartyType = 'PERSON';
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(draftPrescriptionsTranslationKeys.savedNfzDepartment);
            onSuccess();
         },
      }
   );
};
